// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyApL406SEn7o1zWqezNToSpvT1nKK-hcX0",
  authDomain: "e-shop-1-1-1.firebaseapp.com",
  projectId: "e-shop-1-1-1",
  storageBucket: "e-shop-1-1-1.appspot.com",
  messagingSenderId: "766475941221",
  appId: "1:766475941221:web:caa14ff4c5d97556f95d8c",
  measurementId: "G-HDRNXXEC05"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)
const analytics = getAnalytics(app);
const auth = getAuth()
const storage = getStorage(app);
export { db, auth,storage }